export const companyEmailBlacklist = {
  prefixes: new Set([
    'hi',
    'hello',
    'info',
    'sales',
    'contact',
    'enquiries',
    'inquiries',
    'billing',
    'support',
    'helpdesk',
    'howdy',
    'customerservice',
    'careers',
    'partners',
    'affiliates',
    'press',
    'media',
    'staff',
    'shop',
    'services',
    'request',
    'reception',
    'operations',
    'office',
    'legal',
    'jobs',
    'information',
    'general',
    'finance',
    'everyone',
    'customer',
    'customercare',
    'contactus',
    'all',
    'employment',
    'team',
  ]),
  domains: new Set([
    'gmail',
    'hotmail',
    'yahoo',
    'outlook',
    'icloud',
    'aol',
    'mail',
    'gmx',
    'protonmail',
    'zoho',
    'yandex',
    'msn',
    'live',
    'btinternet',
    'btopenworld',
    'talk21',
    'blueyonder',
    'virginmedia',
    'ntlworld',
    'tiscali',
    'onetel',
    'sky',
    'mailinator',
    'tempmail',
    'fastmail',
    'rocketmail',
    'ymail',
    'me',
    'freemail',
  ]),
};
